var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-check-2",
    "data-name": "circle-check",
    d: "M9,1.125A7.875,7.875,0,1,1,1.125,9,7.875,7.875,0,0,1,9,1.125ZM9,18A9,9,0,1,0,0,9,9,9,0,0,0,9,18ZM12.772,7.147a.562.562,0,0,0-.795-.795l-4.1,4.1L6.022,8.6a.562.562,0,0,0-.795.795l2.25,2.25a.564.564,0,0,0,.795,0l4.5-4.5Z",
    fill: "#1976d2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-check.748955ffd90541917e9efd921ceddc18.svg";